<div>
  <div class="card-body">
    <div class="font-weight-bold font-size-36 font-weight-bold text-pink">
      13,846$
    </div>
  </div>
  <div class="position-relative">
    <x-chartist class="ct-chart height-200 ct-hidden-points" [data]="chartData" type="Line" [options]="chartOptions">
    </x-chartist>
  </div>
</div>